import React, { useState, useRef } from 'react';
import { specialTexts } from '../contexts/LangZC';

import encryptedDataImg from '../assets/encrypted-data.png';

function ProductZCSpecial({ featureSectionRef, featureVisible, lang, isMobile = false }) {
  // 가방 애니메이션 상태
  const [bagAction, setBagAction] = useState(false);

  // 1번 박스 스톱워치 상태
  const [watchRunning, setWatchRunning] = useState(false);
  const [watchTime, setWatchTime] = useState(0); // 0.25초 단위로 증가
  const watchInterval = useRef(null);
  const watchTimeout = useRef(null);

  // 2번 박스 사람 깜빡임 상태
  const [personBlink, setPersonBlink] = useState(false); // 사람(머리/몸통) 깜빡임
  const [circleBlink, setCircleBlink] = useState(false); // 원 깜빡임
  const [personBlinkCount, setPersonBlinkCount] = useState(0);
  const personBlinkInterval = useRef(null);

  // 1번 박스 스톱워치
  const handleWatchStart = () => {
    if (watchRunning) return;
    setWatchRunning(true);
    setWatchTime(0);
    watchInterval.current = setInterval(() => {
      setWatchTime(prev => prev + 0.25);
    }, 250);
    // 15초 후 자동 해제
    watchTimeout.current = setTimeout(() => {
      handleWatchStop();
    }, 15000);
  };

  const handleWatchStop = () => {
    setWatchRunning(false);
    clearInterval(watchInterval.current);
    clearTimeout(watchTimeout.current);
    setWatchTime(0);
  };

  // 2번 박스 사람 깜빡임 액션 (교차 깜빡임, 1초 단위)
  const handlePersonBlink = () => {
    if (personBlinkInterval.current) return;
    setPersonBlinkCount(0);
    setPersonBlink(true);
    setCircleBlink(false);
    personBlinkInterval.current = setInterval(() => {
      setPersonBlinkCount(prev => {
        // 교차: 짝수(0,2,4...)는 사람, 홀수(1,3,5...)는 원
        if (prev % 2 === 0) {
          setPersonBlink(true);
          setCircleBlink(false);
        } else {
          setPersonBlink(false);
          setCircleBlink(true);
        }
        if (prev >= 19) { // 10회(20번 토글)
          clearInterval(personBlinkInterval.current);
          personBlinkInterval.current = null;
          setPersonBlink(false);
          setCircleBlink(false);
          return 0;
        }
        return prev + 1;
      });
    }, 1000); // 1초 간격으로 교차, 총 20초(10회)
  };

  // 3번 박스 마우스 오버 시 애니메이션 트리거
  const handleBagAction = () => {
    setBagAction(true);
    setTimeout(() => setBagAction(false), 2000); // 2초 후 초기화
  };

  return (
    <section
      ref={featureSectionRef}
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: 'transparent',
        borderRadius: 16,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        marginBottom: isMobile ? 30 : 40,
        padding: isMobile ? '32px 20px' : '48px 40px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        minHeight: isMobile ? 'auto' : 320
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.6rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 20 : 16,
        textAlign: 'center',
        width: '100%'        // 부모 div 기준으로 가운데 정렬 적용

      }}>
        {specialTexts.title[lang]}
      </span>

      {/* 특징 4가지 박스 2행 2열로 배치 */}
      <div
        className="zc-special-grid"
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: isMobile ? 20 : 32,
          width: '100%',
          margin: isMobile ? '24px 0 32px 0' : '32px 0 40px 0'
        }}
      >
        {/* 첫 번째 줄 (1, 2번 박스) */}
        <div className="zc-special-row" style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 20 : 32, 
          width: '100%' 
        }}>
          {/* 1번 박스 */}
          <div style={{
            flex: isMobile ? 'none' : 1,
            width: isMobile ? '100%' : 'auto',
            background: '#F5F6FA', // 바탕색 변경
            borderRadius: 16,
            padding: isMobile ? 20 : 24,
            color: '#222', // 글씨색 변경
            fontSize: isMobile ? '1rem' : '1.13rem',
            fontWeight: 500,
            boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
            lineHeight: 1.7,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            minHeight: isMobile ? '240px' : 'auto'
          }}
          onMouseEnter={handleWatchStart}
          onMouseLeave={handleWatchStop}
          >
            <span style={{
              fontSize: isMobile ? '1.2rem' : '1.45rem',
              fontWeight: 700,
              display: 'block',
              marginBottom: isMobile ? 12 : 16,
              textAlign: 'left',
              width: '100%',
              color: '#222' // 제목 글씨색
            }}>
              {specialTexts.kerneltitle[lang]}<br />
            </span>
            <div style={{ 
              display: 'flex', 
              flexDirection: isMobile ? 'column' : 'row',
              width: '100%',
              alignItems: isMobile ? 'center' : 'flex-start'
            }}>
              <div style={{ 
                position: 'relative', 
                marginRight: isMobile ? 0 : 32, 
                marginBottom: isMobile ? 16 : 0,
                width: isMobile ? 200 : 384, 
                height: isMobile ? 200 : 384,
                flexShrink: 0
              }}>
                <svg
                  width={isMobile ? "200" : "384"}
                  height={isMobile ? "200" : "384"}
                  viewBox="0 0 96 96"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: 'block', cursor: 'pointer' }}
                >
                  {/* 본체 */}
                  <circle cx="48" cy="56" r="32" stroke="#222" strokeWidth="5" fill="#554fa3"/>
                  {/* 위쪽 버튼 (눌림 애니메이션) */}
                  <rect
                    x="44"
                    y={watchRunning ? 8 : 4}
                    width="8"
                    height={watchRunning ? 14 : 18}
                    rx="2.5"
                    fill="#444" // 짙은회색으로 변경
                    style={{
                      transition: 'all 0.2s cubic-bezier(.4,0,.2,1)'
                    }}
                  />
                  {/* 옆 버튼 */}
                  <rect x="40" y="18" width="16" height="10" rx="3" fill="#444"/>
                  {/* 시침(초침) */}
                  <line
                    x1="48"
                    y1="56"
                    x2={48 + 24 * Math.sin((Math.PI * 2 * (Math.floor(watchTime) % 60)) / 60)}
                    y2={56 - 24 * Math.cos((Math.PI * 2 * (Math.floor(watchTime) % 60)) / 60)}
                    stroke="#ffb300"
                    strokeWidth="5"
                    strokeLinecap="round"
                    style={{
                      transition: watchRunning ? 'none' : 'stroke 0.2s'
                    }}
                  />
                  <circle cx="48" cy="56" r="6" fill="#ffb300"/>
                  <line x1="70" y1="34" x2="80" y2="22" stroke="#444" strokeWidth="3" strokeLinecap="round"/>
                  <line x1="26" y1="34" x2="16" y2="22" stroke="#444" strokeWidth="3" strokeLinecap="round"/>
                </svg>
              </div>
              <div style={{
                flex: isMobile ? 'none' : 1,
                width: isMobile ? '100%' : 'auto',
                whiteSpace: 'pre-line',
                textAlign: isMobile ? 'center' : 'left',
                display: 'flex',
                alignItems: 'center',
                justifyContent: isMobile ? 'center' : 'flex-start',
                color: '#444', // 설명 글씨색
                fontSize: isMobile ? '0.95rem' : '1.13rem',
                lineHeight: isMobile ? 1.6 : 1.7
              }}>
                {specialTexts.kernelmessage[lang]}<br />
              </div>
            </div>
          </div>
          {/* 2번 박스 */}
          <div style={{
            flex: isMobile ? 'none' : 1,
            width: isMobile ? '100%' : 'auto',
            background: '#F5F6FA', // 바탕색 변경
            borderRadius: 16,
            padding: isMobile ? 20 : 24,
            color: '#222', // 글씨색 변경
            fontSize: isMobile ? '1rem' : '1.13rem',
            fontWeight: 500,
            boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
            lineHeight: 1.7,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            minHeight: isMobile ? '240px' : 'auto'
          }}
          onMouseEnter={handlePersonBlink}
          >
            <span style={{
              fontSize: isMobile ? '1.2rem' : '1.45rem',
              fontWeight: 700,
              display: 'block',
              marginBottom: isMobile ? 12 : 16,
              textAlign: 'left',
              width: '100%',
              color: '#222' // 제목 글씨색
            }}>
              {specialTexts.processtitle[lang]}<br />
            </span>
            <div style={{ 
              display: 'flex', 
              flexDirection: isMobile ? 'column' : 'row',
              width: '100%',
              alignItems: isMobile ? 'center' : 'flex-start'
            }}>
              <div style={{
                marginRight: isMobile ? 0 : 32,
                marginBottom: isMobile ? 16 : 0,
                flexShrink: 0
              }}>
                <svg
                  width={isMobile ? "200" : "384"}
                  height={isMobile ? "200" : "384"}
                  viewBox="0 0 147 145"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                {/* 방패 외곽 - 선을 더 굵게 */}
                <path
                  d="M73.5 16L127 32.5V66.5C127 104.5 73.5 129 73.5 129C73.5 129 20 104.5 20 66.5V32.5L73.5 16Z"
                  stroke="#222" // 검정색으로 변경
                  strokeWidth="8"
                  fill="none"
                />
                {/* 사람 원형 배경 - 방패 중앙, 교차 깜빡임 */}
                <circle
                  cx="73.5"
                  cy="75"
                  r="28"
                  stroke={circleBlink ? "#ffb300" : "#444"} // 짙은회색으로 변경
                  strokeWidth="4"
                  fill="none"
                  style={{
                    filter: circleBlink ? 'drop-shadow(0 0 8px #ffb300)' : 'none'
                  }}
                />
                {/* 사람 머리 - 교차 깜빡임 */}
                <circle
                  cx="73.5"
                  cy="68"
                  r="7"
                  stroke={personBlink ? "#ffb300" : "#444"} // 짙은회색으로 변경
                  strokeWidth="3"
                  fill="none"
                  style={{
                    filter: personBlink ? 'drop-shadow(0 0 8px #ffb300)' : 'none'
                  }}
                />
                {/* 사람 어깨/몸통 - 교차 깜빡임 */}
                <path
                  d="M60.5 92c0-7.18 5.82-13 13-13s13 5.82 13 13"
                  stroke={personBlink ? "#ffb300" : "#444"} // 짙은회색으로 변경
                  strokeWidth="3"
                  fill="none"
                />
              </svg>
              </div>
              <div style={{
                flex: isMobile ? 'none' : 1,
                width: isMobile ? '100%' : 'auto',
                textAlign: isMobile ? 'center' : 'left',
                display: 'flex',
                alignItems: 'center',
                justifyContent: isMobile ? 'center' : 'flex-start',
                color: '#444', // 설명 글씨색
                fontSize: isMobile ? '0.95rem' : '1.13rem',
                lineHeight: isMobile ? 1.6 : 1.7
              }}>
                {specialTexts.processmessage[lang]}
              </div>
            </div>
          </div>
        </div>
        {/* 두 번째 줄 (3, 4번 박스) */}
        <div className="zc-special-row" style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 20 : 32, 
          width: '100%' 
        }}>
          {/* 3번 박스 */}
          <div style={{
            flex: isMobile ? 'none' : 1,
            width: isMobile ? '100%' : 'auto',
            background: '#F5F6FA', // 바탕색 변경
            borderRadius: 16,
            padding: isMobile ? 20 : 24,
            color: '#222', // 글씨색 변경
            fontSize: isMobile ? '1rem' : '1.13rem',
            fontWeight: 500,
            boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
            lineHeight: 1.7,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start'
          }}
          onMouseEnter={handleBagAction}
          >
            <span style={{
              fontSize: isMobile ? '1.2rem' : '1.45rem',
              fontWeight: 700,
              display: 'block',
              marginBottom: isMobile ? 12 : 16,
              textAlign: 'left',
              width: '100%',
              color: '#222' // 제목 글씨색
            }}>
              {specialTexts.containertitle[lang]}<br />
            </span>
            <div style={{ 
              display: 'flex', 
              flexDirection: isMobile ? 'column' : 'row',
              width: '100%',
              alignItems: isMobile ? 'center' : 'flex-start'
            }}>
              <div style={{
                marginRight: isMobile ? 0 : 32,
                marginBottom: isMobile ? 16 : 0,
                flexShrink: 0
              }}>
                <svg
                  width={isMobile ? "200" : "384"}
                  height={isMobile ? "200" : "384"}
                  viewBox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ cursor: 'pointer' }}
                >
                {/* 가방 본체 */}
                <rect x="16" y="28" width="48" height="32" rx="6" fill="#554fa3" stroke="#222" strokeWidth="4"/>
                {/* 가방 덮개(애니메이션) */}
                <rect
                  x="16"
                  y="18"
                  width="48"
                  height="16"
                  rx="6"
                  fill="#6a65c2"
                  stroke="#222"
                  strokeWidth="3"
                  style={{
                    transformOrigin: '40px 34px',
                    transform: bagAction
                      ? 'rotateX(60deg) translateY(-16px) scaleY(0.5)'
                      : 'rotateX(0deg) translateY(0) scaleY(1)',
                    transition: 'transform 0.5s cubic-bezier(.4,0,.2,1)'
                  }}
                />
                {/* 손잡이 */}
                <rect x="30" y="12" width="20" height="8" rx="4" fill="#fff" stroke="#554fa3" strokeWidth="2"/>
                {/* 자물쇠 */}
                <rect x="37" y="38" width="6" height="8" rx="2" fill="#ffb300" stroke="#fff" strokeWidth="2"/>
                {/* 워드 문서 (애니메이션) */}
                <g style={{
                  opacity: bagAction ? 1 : 0,
                  transform: bagAction
                    ? 'translate(0px, 0px)'
                    : 'translate(0px, -30px)',
                  transition: 'opacity 0.3s 0.4s, transform 0.5s 0.4s'
                }}>
                  <rect x="48" y="10" width="14" height="20" rx="2" fill="#185abd" stroke="#fff" strokeWidth="2"/>
                  <text x="55" y="25" fontSize="10" fontWeight="bold" fill="#fff" fontFamily="Arial, sans-serif" textAnchor="middle">W</text>
                </g>
              </svg>
              </div>
              <div style={{
                flex: isMobile ? 'none' : 1,
                width: isMobile ? '100%' : 'auto',
                textAlign: isMobile ? 'center' : 'left',
                display: 'flex',
                alignItems: 'center',
                justifyContent: isMobile ? 'center' : 'flex-start',
                color: '#444', // 설명 글씨색
                fontSize: isMobile ? '0.95rem' : '1.13rem',
                lineHeight: isMobile ? 1.6 : 1.7
              }}>
                {specialTexts.containermessage[lang]}
              </div>
            </div>
          </div>
          {/* 4번 박스 */}
          <div style={{
            flex: isMobile ? 'none' : 1,
            width: isMobile ? '100%' : 'auto',
            background: '#F5F6FA', // 바탕색 변경
            borderRadius: 16,
            padding: isMobile ? 20 : 24,
            color: '#222', // 글씨색 변경
            fontSize: isMobile ? '1rem' : '1.13rem',
            fontWeight: 500,
            boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
            lineHeight: 1.7,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 16
          }}>
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {/* SVG 영역, 필요시 여기에 SVG를 추가하세요 */}
            </div>
            <div style={{ flex: 1 }}>
              <span style={{
                fontSize: isMobile ? '1.2rem' : '1.45rem',
                fontWeight: 700,
                display: 'block',
                marginBottom: isMobile ? 12 : 16,
                color: '#222' // 제목 글씨색
              }}>
                {specialTexts.allfiletitle[lang]}<br />
              </span>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginTop: 12,
                background: '#554fa3',
                color: '#fff',
                borderRadius: 8,
                overflow: 'hidden',
                fontSize: isMobile ? '0.85rem' : '1.05rem'
              }}>
                <thead>
                  <tr>
                    {specialTexts.table.header[lang].map((th, idx) => (
                      <th
                        key={idx}
                        style={{
                          background: '#6a65c2',
                          padding: isMobile ? '6px 4px' : '8px 6px',
                          textAlign: idx === 0 ? 'left' : 'center',
                          fontWeight: 'bold',
                          fontSize: isMobile ? '0.85rem' : '1.05rem'
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {specialTexts.table.rows.map((row, idx) => (
                    <tr key={idx}>
                      {row[lang].map((td, tdIdx) => (
                        <td
                          key={tdIdx}
                          style={{
                            padding: tdIdx === 0 ? (isMobile ? '5px 4px' : '7px 6px') : (isMobile ? '5px 2px' : undefined),
                            textAlign: tdIdx === 0 ? 'left' : 'center',
                            borderBottom: '2px solid #6a65c2',
                            color: tdIdx === 2 ? '#ffb300' : undefined,
                            fontWeight: tdIdx === 2 ? 'bold' : undefined,
                            fontSize: isMobile ? '0.8rem' : 'inherit'
                          }}
                        >
                          {td}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductZCSpecial;